import { QuanlythenapService } from 'src/services/quanlythenap.service';
import { showToast } from 'src/utils/common';
import { NOTI_TYPES } from 'src/utils/constants';

import { AppAction } from './app.action';

export const QUANLYTHENAP_NEW_CARE_SUCCESS = 'QUANLYTHENAP:NEW_CARE_SUCCESS'
export const QUANLYTHENAP_LIST_SUCCESS = 'QUANLYTHENAP:FIND_ALL_SUCCESS'
export const QUANLYTHENAP_LIST_FAILD = 'QUANLYTHENAP:FIND_ALL_FAILD'
export const QUANLYTHENAP_COUNT_ASSIGN_SUCCESS = 'QUANLYTHENAP:COUNT_ASSIGN_SUCCESS'
export const QUANLYTHENAP_COUNT_ASSIGN_FAILD = 'QUANLYTHENAP:COUNT_ASSIGN_FAILD'

export const QUANLYTHENAP_CREATE_SUCCESS = 'QUANLYTHENAP:CREATE_SUCCESS'
export const QUANLYTHENAP_CREATE_FAILD = 'QUANLYTHENAP:CREATE_FAILD'

export const QUANLYTHENAP_IMPORT_SUCCESS = 'QUANLYTHENAP:IMPORT_SUCCESS'
export const QUANLYTHENAP_SAVE_SUCCESS = 'QUANLYTHENAP:SAVE_SUCCESS'
export const QUANLYTHENAP_SAVE_FAILD = 'QUANLYTHENAP:SAVE_SUCCESS'

export const QUANLYTHENAP_DEL_SUCCESS = 'QUANLYTHENAP:DEL_SUCCESS'
export const QUANLYTHENAP_DEL_FAILD = 'QUANLYTHENAP:DEL_FAILD'

export const QUANLYTHENAP_ONE_SUCCESS = 'QUANLYTHENAP:FIND_ONE_SUCCESS'
export const QUANLYTHENAP_ONE_FAILD = 'QUANLYTHENAP:FIND_ONE_FAILD'

export const QUANLYTHENAP_HISTORY_LIST_SUCCESS = 'QUANLYTHENAP:HISTORY_FIND_ALL_SUCCESS'
export const QUANLYTHENAP_HISTORY_LIST_FAILD = 'QUANLYTHENAP:HISTORY_FIND_ALL_FAILD'

export const QUANLYTHENAP_UPDATE_FILTER = 'QUANLYTHENAP:UPDATE_FILTER'

export const QUANLYTHENAPCOMLIST_LIST_SUCCESS = 'QUANLYTHENAPCOMLIST:FIND_ALL_SUCCESS'
export const QUANLYTHENAPCOMLIST_LIST_FAILD = 'QUANLYTHENAPCOMLIST:FIND_ALL_FAILD'

export const QuanlythenapAction = {
    list,
    findAssign,
    create,
    importData,
    saveData,
    update,
    del,
    assign,
    countAssign,
    history,
    findOne,
    approve,
    updateFilter,
    batTatLoaiDichVu,
    xoaMucDaChon,
    findAllByOrder,
    yeuCauChayLaiCallback,
    handleSuaNhieuMuc,
}

function updateFilter(payload) {
    return { type: QUANLYTHENAP_UPDATE_FILTER, data: payload }
}

function handleSuaNhieuMuc(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            const { quanlythenap } = getState();            
            // Perform your asynchronous operation (e.g., API call)
            QuanlythenapService.handleSuaNhieuMuc(payload)
            .then(response => {
                dispatch(success(response));
                dispatch(QuanlythenapAction.list());
                resolve(response);
            })
            .catch(error => {
                dispatch(failure(error));
                reject(error);
            });
        });
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function yeuCauChayLaiCallback(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.yeuCauChayLaiCallback(id).then((rs) => {
            dispatch(success(rs.data));
            dispatch(QuanlythenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function batTatLoaiDichVu(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            QuanlythenapService.batTatLoaiDichVu(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(QuanlythenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function xoaMucDaChon(payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            QuanlythenapService.xoaMucDaChon(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(QuanlythenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function approve(id, payload) {    
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            // Perform your asynchronous operation (e.g., API call)
            QuanlythenapService.approve(id, payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(QuanlythenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            });
        });
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function countAssign() {
    return (dispatch) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.countAssign().then((rs) => {
            dispatch(success(rs.data.total));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_COUNT_ASSIGN_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_COUNT_ASSIGN_FAILD, error } }
}

function findAssign(page = 0, count = 20) {
    return (dispatch, getState) => {
        const { quanlythenap } = getState()
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.findAssign(page, count).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...quanlythenap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_LIST_FAILD, error } }
}

function findAllByOrder(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { quanlythenap } = getState();
        const page = quanlythenap && typeof quanlythenap.filter !== 'undefined' && quanlythenap.filter && typeof quanlythenap.filter.page !== 'undefined' ? quanlythenap.filter.page : 0;
        const limit = quanlythenap && typeof quanlythenap.filter !== 'undefined' && quanlythenap.filter && typeof quanlythenap.filter.limit !== 'undefined' ? quanlythenap.filter.limit : 10;
        QuanlythenapService.findAllByOrder(id, page, limit, quanlythenap.filter).then((rs) => {
            if (page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                const oldItems = quanlythenap.quanlythenapcomlist_items;
                const rsDataValues = rs.data.values;

                var uniqueItems = oldItems;
                for (var i = limit * page; i < limit * page + limit; i++) {
                    if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                        uniqueItems[i] = rsDataValues[i - limit * page];
                    } else if (typeof uniqueItems[i] !== 'undefined') {
                        delete uniqueItems[i];
                    }
                }
                
                console.log({
                    items: uniqueItems,
                    total: rs.data.count
                })
                dispatch(success({
                    items: uniqueItems,
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAPCOMLIST_LIST_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAPCOMLIST_LIST_FAILD, error } }
}

function list() {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        const { quanlythenap } = getState();
        const page = quanlythenap && typeof quanlythenap.filter !== 'undefined' && quanlythenap.filter && typeof quanlythenap.filter.page !== 'undefined' ? quanlythenap.filter.page : 0;
        const limit = quanlythenap && typeof quanlythenap.filter !== 'undefined' && quanlythenap.filter && typeof quanlythenap.filter.limit !== 'undefined' ? quanlythenap.filter.limit : 10;
        
        return new Promise((resolve, reject) => {
            QuanlythenapService.findAll(page, limit, quanlythenap.filter).then((rs) => {
                if (page === 0) {
                    dispatch(success({
                        items: rs.data.values,
                        total: rs.data.count,
                        tong_sai_menh_gia: rs.data.tong_sai_menh_gia,
                        tong_dung_menh_gia: rs.data.tong_dung_menh_gia,
                        tong_loi_huy: rs.data.tong_loi_huy,
                        tong_doi_soat: rs.data.tong_doi_soat,
                        tong_chua_nap: rs.data.tong_chua_nap,
                        tong_nap: rs.data.tong_nap,
                        tong_the: rs.data.tong_the,
                    }));
                } else {
                    const oldItems = quanlythenap.items;
                    const rsDataValues = rs.data.values;

                    var uniqueItems = oldItems;
                    for (var i = limit * page; i < limit * page + limit; i++) {
                        if (typeof rsDataValues[i - limit * page] !== 'undefined') {
                            uniqueItems[i] = rsDataValues[i - limit * page];
                        } else if (typeof uniqueItems[i] !== 'undefined') {
                            delete uniqueItems[i];
                        }
                    }
                    
                    dispatch(success({
                        items: uniqueItems,
                        total: rs.data.count,
                        tong_sai_menh_gia: rs.data.tong_sai_menh_gia,
                        tong_dung_menh_gia: rs.data.tong_dung_menh_gia,
                        tong_loi_huy: rs.data.tong_loi_huy,
                        tong_doi_soat: rs.data.tong_doi_soat,
                        tong_chua_nap: rs.data.tong_chua_nap,
                        tong_nap: rs.data.tong_nap,
                        tong_the: rs.data.tong_the,
                    }));
                }

                resolve(rs);
            }).catch((error) => {
                dispatch(failure(error));
                reject(error);
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            })
        });
    };
    function success(data) { return { type: QUANLYTHENAP_LIST_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_LIST_FAILD, error } }
}

function importData(payload) {
    return { type: QUANLYTHENAP_IMPORT_SUCCESS, data: payload }
}

function saveData(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        let count = 0
        for (let i = 0; i < payload.length; i += 200) {
            // eslint-disable-next-line no-loop-func
            QuanlythenapService.save(payload.slice(i, i + 200)).then((rs) => {
                count += parseInt(rs.data.saved, 10)
                if (count === payload.length) {
                    dispatch(success(rs));
                    dispatch(QuanlythenapAction.list())
                    dispatch(AppAction.appLoading(false));
                }
            }).catch((error) => {
                dispatch(failure(error));
                dispatch(AppAction.appLoading(false));
            })
        }
    };

    function success(data) { return { type: QUANLYTHENAP_SAVE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_SAVE_FAILD, error } }
}

function create(payload) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(AppAction.appLoading(true));
            // Perform your asynchronous operation (e.g., API call)
            QuanlythenapService.create(payload)
            .then(response => {
                // Handle the successful response
                dispatch(success(response));
                dispatch(QuanlythenapAction.list());
                resolve(response); // Resolve the promise with the response
            })
            .catch(error => {
                // Handle the error
                dispatch(failure(error));
                reject(error); // Reject the promise with the error
            }).finally(() => {
                dispatch(AppAction.appLoading(false));
            });
        });
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function update(id, payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.update(id, payload).then((rs) => {
            dispatch(success(rs));
            dispatch(QuanlythenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_CREATE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_CREATE_FAILD, error } }
}

function del(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.delete(id).then((rs) => {
            dispatch(success(rs));
            dispatch(QuanlythenapAction.list())
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_DEL_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_DEL_FAILD, error } }
}

function findOne(id) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.find(id).then((rs) => {
            dispatch(success(rs.data));
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_ONE_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_ONE_FAILD, error } }
}

function assign(payload) {
    return (dispatch, getState) => {
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.assign(payload).then((rs) => {
            showToast('success', "Phân chia dữ liệu thành công.")
            dispatch(QuanlythenapAction.list())
        }).catch((error) => {
            showToast('error', "Phân chia dữ liệu thất bại.\nVui lòng thử lại lần sau.")
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
}


function history(payload) {
    return (dispatch, getState) => {
        const { quanlythenap } = getState()
        dispatch(AppAction.appLoading(true));
        QuanlythenapService.history(payload).then((rs) => {
            if (payload.page === 0) {
                dispatch(success({
                    items: rs.data.values,
                    total: rs.data.count
                }));
            } else {
                dispatch(success({
                    items: [...quanlythenap.items, ...rs.data.values],
                    total: rs.data.count
                }));
            }
        }).catch((error) => {
            dispatch(failure(error));
        }).finally(() => {
            dispatch(AppAction.appLoading(false));
        })
    };
    function success(data) { return { type: QUANLYTHENAP_HISTORY_LIST_SUCCESS, data } }
    function failure(error) { return { type: QUANLYTHENAP_HISTORY_LIST_FAILD, error } }
}